import { Component } from 'react';
import AWS from 'aws-sdk';
import Cognito from "src/js/Cognito.js";
import apigClientFactory from 'aws-api-gateway-client';
import Config from 'src/config.json';

/*
  APIに関する処理のまとめ
*/
class Api extends Component {

  static createApigClient() {

    let apigClientConfig = {
      // APIのURL ここは固定にする
      invokeUrl: Config.API.URL,
      // ログイン済みユーザのアクセスキー
      accessKey: AWS.config.credentials.accessKeyId,
      // ログイン済みユーザのシークレットキー
      secretKey: AWS.config.credentials.secretAccessKey,
      // ログイン済みユーザのセッショントークン
      sessionToken: AWS.config.credentials.sessionToken,
      // APIGatewayのリージョン
      region: Config.AWS.REGION
    };
    return (apigClientFactory.newClient(apigClientConfig));
  }

  static invokeApi(invokeConfig) {

    let _this = this;

    return new Promise(function (resolve, reject) {
      let apigClient = _this.createApigClient();
      apigClient.invokeApi(
        invokeConfig.params,
        invokeConfig.pathTemplate,
        invokeConfig.method,
        invokeConfig.additionalParams,
        invokeConfig.body
      ).then(function (result) {
        resolve(result);
      }).catch(function (result) {
        reject(result);
      });
    });
  }

  static runApi(cognitoUser, path, queryParams) {
    let _this = this;

    // API実行オプション
    let invokeConfig = {
      params: {},
      pathTemplate: path,
      method: Config.API.METHOD_TYPE,
      additionalParams: {
        headers: {},
        queryParams: queryParams
      },
      body: {}
    };

    return new Promise(function (resolve, reject) {
      // 認証情報をセット
      Cognito.setCredentials(cognitoUser)
        .then(function () {
          let getPromise = AWS.config.credentials.getPromise()
          getPromise.then(function () {
            // 認証情報の更新
            // 空の非同期処理を作成
            let refreshPromise = new Promise(function (resolve, reject) {
              resolve();
            });
            // 更新が必要なら更新用の非同期処理を代入
            if (AWS.config.credentials.needsRefresh()) {
              console.log("credentials reposession")
              refreshPromise = AWS.config.credentials.refreshPromise();
            }
            refreshPromise.then(function () {
              _this.invokeApi(invokeConfig).then(function (result) {
                resolve(result);
              }).catch(function (err) {
                reject(err);
              });
            }).catch(function (err) {
              reject(err);
            });
          }).catch(function (err) {
            reject(err);
          });
        }).catch(function (err) {
          reject(err);
        })
    });
  }
}

export default Api;



// WEBPACK FOOTER //
// ./src/js/Api.js